import type { ExtendedListParams } from '@/types/search-criteria';
import type { ShowcasePricesParams } from '@/types/price';

export const queryKeys = {
  prices: {
    all: ['prices'] as const,
    showcase: (params: ShowcasePricesParams) =>
      [...queryKeys.prices.all, 'showcase', params] as const,
  },
  contracts: {
    all: (customerId: number) => ['contracts', customerId] as const,
    list: (customerId: number, params?: ExtendedListParams) =>
      [...queryKeys.contracts.all(customerId), 'list', params] as const,
    detail: (customerId: number, id: number) =>
      [...queryKeys.contracts.all(customerId), 'detail', id] as const,
    lineDetails: (customerId: number, id: number) =>
      [...queryKeys.contracts.all(customerId), 'lineDetails', id] as const,
  },
  invoices: {
    all: (customerId: number) => ['invoices', customerId] as const,
    list: (customerId: number, params?: ExtendedListParams) =>
      [...queryKeys.invoices.all(customerId), 'list', params] as const,
    byContract: (customerId: number, contractId: number) =>
      [...queryKeys.invoices.all(customerId), 'byContract', contractId] as const,
    detail: (customerId: number, id: number) =>
      [...queryKeys.invoices.all(customerId), 'detail', id] as const,
  },
  guard: {
    all: (customerId: number) => ['guard', customerId] as const,
    pinCodes: (customerId: number) => [...queryKeys.guard.all(customerId), 'pinCodes'] as const,
  },
  customer: {
    all: (customerId: number) => ['customer', customerId] as const,
    me: (customerId: number) => [...queryKeys.customer.all(customerId), 'me'] as const,
  },
  payments: {
    all: (customerId: number) => ['payments', customerId] as const,
    options: (customerId: number) => [...queryKeys.payments.all(customerId), 'options'] as const,
    detail: (customerId: number, paymentId: string) =>
      [...queryKeys.payments.all(customerId), 'detail', paymentId] as const,
    vault: (customerId: number) => [...queryKeys.payments.all(customerId), 'vault'] as const,
  },
  facilities: {
    all: ['facilities'] as const,
    list: () => ['facilities', 'list'] as const,
    detail: (code: string) => ['facilities', 'detail', code] as const,
    statistics: (code: string) => ['facilities', 'statistics', code] as const,
  },
  units: {
    all: ['units'] as const,
    byFacility: (facilityCode: string) => ['units', 'byFacility', facilityCode] as const,
    detail: (facility: string, unitType: string, code: string) =>
      ['units', 'detail', facility, unitType, code] as const,
  },
};
